module.exports = __webpack_public_path__ + "e115fe8ba4efd2b128f88e90ee759b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescenceScale/medium@2x.png
// module id = 862
// module chunks = 0